"use strict";
/**
 * Appeals Domain Database Types
 *
 * Appeal records for content moderation appeals.
 * Previously inline (no named type) in lambda-secure/src/routes/appeal-system.ts.
 */
Object.defineProperty(exports, "__esModule", { value: true });
